import { useDispatch } from 'react-redux';
import { BroadcastChannel } from 'broadcast-channel';

import { removeAccessToken } from 'utils/accessToken';
import { logoutSuccess } from 'routes/AppContainer/actions';
import { getControlCenterOrigin } from 'utils/getControlCenterOrigin';
import { getWindowLocation } from 'utils/window';

import { useOpMutation } from './useOpMutation';

export const useLogout = () => {
  const logoutMutation = useOpMutation({
    apiEndpointName: 'logout',
  });

  const dispatch = useDispatch();

  const logout = async () => {
    await logoutMutation.mutateAsync({});

    removeAccessToken();

    // tell oxygen to disconnect
    const broadcastChannel = new BroadcastChannel('oxygen');
    broadcastChannel.postMessage({
      command: 'DISCONNECT',
      target: '*',
      sender: 'logout',
    });

    // Clears out redux data when called in control center
    dispatch(logoutSuccess());

    const windowLocation = getWindowLocation();
    // handle control center and other apps on both alta.avigilon and openpath domains.
    const controlCenterOrigin =
      getControlCenterOrigin() ?? windowLocation.origin;

    // this hook is used by different apps which dont all have their own login page thus we need to hard set the url vs using react router
    windowLocation.href = `${controlCenterOrigin}/signin`;
  };

  return { logout };
};
